import styled from "styled-components";

export const ArticleSt = styled.article`
  h2 {
    font-size: 20px;
    margin-bottom: 16px;
  }
  margin-bottom: 30px;
`;

export const MainSt = styled.main`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MainRows = styled.main`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 30px;
`;
